import { render } from "./Tab2View.vue?vue&type=template&id=29906e71&scoped=true"
import script from "./Tab2View.vue?vue&type=script&lang=js"
export * from "./Tab2View.vue?vue&type=script&lang=js"

import "./Tab2View.vue?vue&type=style&index=0&id=29906e71&scoped=true&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29906e71"]])

export default __exports__